var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBrilliance = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 88 95",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 0c.345 0 .68.044 1 .126A4 4 0 0 1 49 4c0 16.053 6 25.62 13.112 31.267C69.402 41.054 78.225 43 84 43a4 4 0 0 1 3.97 4.5A4 4 0 0 1 84 52c-5.775 0-14.599 1.946-21.888 7.733C54.999 65.379 49 74.947 49 91a4 4 0 0 1-5 3.874A4.005 4.005 0 0 1 39 91c0-16.053-6-25.62-13.112-31.267C18.598 53.946 9.775 52 4 52a4 4 0 0 1-3.97-4.5A4 4 0 0 1 4 43c5.775 0 14.599-1.946 21.888-7.733C33.001 29.621 39 20.053 39 4a4 4 0 0 1 4-4ZM20.703 47.5c3.448 1.442 6.916 3.393 10.159 5.967C36.375 57.844 41.111 63.924 44 72.09c2.889-8.166 7.625-14.246 13.138-18.623 3.243-2.574 6.71-4.525 10.158-5.967-3.447-1.442-6.915-3.393-10.158-5.967C51.625 37.156 46.889 31.076 44 22.91c-2.889 8.166-7.625 14.246-13.138 18.623-3.243 2.574-6.71 4.525-10.159 5.967Z",
  fill: "#7DFFBA"
})));

export default SvgBrilliance;